import { usePostMutation, usePutMutation } from "slices/api";
import {
  UTILITY_TUNNEL,
  ACCESS_APPLICATION,
  APPROVAL_TRACKING,
} from "tagTypes";

export const usePostLoginUserMutation = () => {
  const [loginUser, data] = usePostMutation();
  const login = async (payload, query = {}) => {
    return await loginUser({
      endpoint: "/uta-card-issuance-user/login",
      query,
      payload: payload || {},
      tags: [UTILITY_TUNNEL],
    }).unwrap();
  };
  return [login, data];
};

export const usePostRegisterEmployeeOrContractorMutation = () => {
  const [registerUser, data] = usePostMutation();
  const register = async (payload, query = {}) => {
    return await registerUser({
      endpoint: "/uta-card-issuance-user/register-employee-or-contractor",
      query,
      payload: payload || {},
      toastMessage: "Registered successfully",
      tags: [UTILITY_TUNNEL],
    }).unwrap();
  };
  return [register, data];
};

export const usePutUpdateUtilityTunnelApplicationStatusMutation = () => {
  const [updateStatus, data] = usePutMutation();
  const updateApplicationStatus = async (payload = {}) =>
    await updateStatus({
      endpoint: "/access-detail/approve",
      payload,
      toastMessage: "Application request updated successfully",
      tags: [ACCESS_APPLICATION, APPROVAL_TRACKING],
    }).unwrap();
  return [updateApplicationStatus, data];
};
